import React from 'react';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';
import theLayoutStyles from "./layoutStyles";



export default function StickyFooter() {
  const classes = theLayoutStyles();

  function Copyright() {
    return (
        <Typography className={classes.footerText} >
        {'Copyright © '}
        <Link color="inherit" href="https://deep-questions.gitlab.io/gatsby/">
            Deep Questions
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
        </Typography>
    );
    }

  return (
      <footer className={classes.footer}>
        <Container maxWidth="sm">
          <Copyright />
        </Container>
      </footer>
    
  );
}
